import { render, staticRenderFns } from "./ModificationView.vue?vue&type=template&id=72a9a8d7&"
import script from "./ModificationView.vue?vue&type=script&lang=js&"
export * from "./ModificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports